// Generated file : do not modify
export enum GraphQuestionTypes
{
  NONE = 0,
  ENTIER,
  BOOL,
  CHOIX
};

import GraphSolution from '@/extend/classes/GraphSolution';
import { GraphAnswer } from '@/extend/classes/GraphData';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Questions des graphes
export class GraphChoix {
  // Libellé
  public label: string;
  // solution ou nombre choisi
  public value: string;

  constructor() {
    this.label = '';
    this.value = '';
  }
}

export default class GraphQuestion  {
  // Identifiant unique
  public id: number;
  // id graph
  public graphId: number;
  // Convention
  public convention: string;
  // Code
  public code: string;
  // Donnee
  public donnee: string;
  // Calculée
  public calcul: boolean;
  // ReadOnly
  public readOnly: boolean;
  // Libellé
  public label: string;
  // Aide
  public aide: string;
  // Type de question
  public type: GraphQuestionTypes;
  // Objet
  public objType: ObjTypes;
  // id des solutions
  public solutionIds: number[];
  // Liste des choix à trier
  public sortChoix: boolean;
  // Solutions
  public solutions: GraphSolution[];
  // Liste des choix
  public choix: GraphChoix[];
  // Valeur choisie
  public answer: GraphAnswer;
  // Aide
  public aideHtmlId: number;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.graphId = 0;
    this.convention = '';
    this.code = '';
    this.donnee = '';
    this.calcul = false;
    this.readOnly = false;
    this.label = '';
    this.aide = '';
    this.type = GraphQuestionTypes.NONE;
    this.objType = ObjTypes.NONE;
    this.solutionIds = [];
    this.sortChoix = false;
    this.solutions = [];
    this.choix = [];
    this.answer = new GraphAnswer();
    this.aideHtmlId = 0;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: GraphQuestion): GraphQuestion {
    const newGraphQuestion: GraphQuestion = new GraphQuestion();
    newGraphQuestion.id = obj.id;
    newGraphQuestion.graphId = obj.graphId;
    newGraphQuestion.convention = obj.convention;
    newGraphQuestion.code = obj.code;
    newGraphQuestion.donnee = obj.donnee;
    newGraphQuestion.calcul = obj.calcul;
    newGraphQuestion.readOnly = obj.readOnly;
    newGraphQuestion.label = obj.label;
    newGraphQuestion.aide = obj.aide;
    newGraphQuestion.type = obj.type;
    newGraphQuestion.objType = obj.objType;
    newGraphQuestion.solutionIds = JSON.parse(JSON.stringify(obj.solutionIds));
    newGraphQuestion.sortChoix = obj.sortChoix;
    newGraphQuestion.solutions = JSON.parse(JSON.stringify(obj.solutions));
    newGraphQuestion.choix = JSON.parse(JSON.stringify(obj.choix));
    newGraphQuestion.answer = JSON.parse(JSON.stringify(obj.answer));
    newGraphQuestion.aideHtmlId = obj.aideHtmlId;
    newGraphQuestion.canUpdate = obj.canUpdate;
    newGraphQuestion.canDelete = obj.canDelete;
    newGraphQuestion.display = obj.display;
    newGraphQuestion.notifDefType = obj.notifDefType;
    return newGraphQuestion;
  }

  public toJsonGraphQuestion (): string {
    const json = {
      graphId: this.graphId,
      convention: this.convention,
      code: this.code,
      donnee: this.donnee,
      calcul: this.calcul,
      readOnly: this.readOnly,
      label: this.label,
      aide: this.aide,
      type: this.type,
      objType: this.objType,
      solutionIds: this.solutionIds,
      sortChoix: this.sortChoix,
      solutions: this.solutions,
      choix: this.choix,
      answer: this.answer,
      aideHtmlId: this.aideHtmlId,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromGraphQuestion (obj: GraphQuestion): void {
    this.id = obj.id;
    this.graphId = obj.graphId;
    this.convention = obj.convention;
    this.code = obj.code;
    this.donnee = obj.donnee;
    this.calcul = obj.calcul;
    this.readOnly = obj.readOnly;
    this.label = obj.label;
    this.aide = obj.aide;
    this.type = obj.type;
    this.objType = obj.objType;
    this.solutionIds = obj.solutionIds;
    this.sortChoix = obj.sortChoix;
    this.solutions = obj.solutions;
    this.choix = obj.choix;
    this.answer = obj.answer;
    this.aideHtmlId = obj.aideHtmlId;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareGraphQuestion (value: GraphQuestion): boolean {
    return (this.toJsonGraphQuestion() == value.toJsonGraphQuestion());
  }

  public cloneGraphQuestion (): GraphQuestion {
    return GraphQuestion.fromJson(this);
  }

  // eslint-disable-next-line
  public static getDate(graphQuestions: GraphQuestion[]) {
  }
}
